import { Injectable } from '@angular/core';


import { CusHttp } from '../../core/services/CusHttp';

//城市列表信息
const CITYLIST = "v1/region/post-city?num=6";
// 通用下拉列表选项接口
const OPTIONMASTER = "v1/option-data/list?option_master_id=";
//行业领域列表接口
const INDUSTRYURL = 'v1/industry/tree';
//岗位类型列表接口
const JOBCLASSURL = "v1/position-industry/tree";
//期望岗位
const HopeJobURL = 'v1/public/hope-category';
@Injectable()
export class CategoryOptionService {
  public openCityList: any; //开通地址
  public degreeList: any;//学位缓存
  public salaryList: any;  //薪资范围
  public workTime: any;  //求职状态
  public sexList: any; //性别信息
  public industryList: any; //行业类别
  public proficiencyList: any; //技术熟练度
  public scaleList: any; //企业规模
  constructor(
    public _http: CusHttp,
  ) { }

  //获取城市信息
  getCategoryCity() {
    if (!this.openCityList) {
      return this._http.get(CITYLIST).then((data) => {
        this.openCityList = data;
        return this.openCityList;
      });
    } else {
      return Promise.resolve(this.openCityList);
    }
  };
  //获取性别信息
  getSexList() {
    let sexId = 14;
    if (!this.sexList) {
      return this._http.get(OPTIONMASTER + sexId).then((data) => {
        this.sexList = data;
        return this.sexList;
      });
    } else {
      return Promise.resolve(this.sexList);
    }
  }
  //获取企业规模
  getScaleList() {
    let scaleId = 9;
    if (!this.scaleList) {
      return this._http.get(OPTIONMASTER + scaleId).then((data) => {
        this.scaleList = data;
        return this.scaleList;
      });
    } else {
      return Promise.resolve(this.scaleList);
    }
  }
  getProficiencyList() {
    let proficeId = 19;
    if (!this.proficiencyList) {
      return this._http.get(OPTIONMASTER + proficeId).then((data) => {
        this.proficiencyList = data;
        return this.proficiencyList;
      });
    } else {
      return Promise.resolve(this.proficiencyList);
    }
  }

  //从数据库获取求职状态（到岗时间）列表 通用下拉列表选项接口
  getWorkTime() {
    let timeId = 11;
    if (!this.workTime) {
      return this._http.get(OPTIONMASTER + timeId).then((data) => {
        this.workTime = data;
        return this.workTime;
      });
    } else {
      return Promise.resolve(this.workTime);
    }
  }
  //获取学位信息  通用下拉列表选项接口
  getCategoryDegree() {
    let degreeID = 12;
    if (!this.degreeList) {
      return this._http.get(OPTIONMASTER + degreeID).then((data) => {
        this.degreeList = data;
        return this.degreeList;
      });
    } else {
      return Promise.resolve(this.degreeList);
    }
  }



  //公司性质
  getCategoryNature() {
    //公司ID  ---8
    let natureID = 8;
    // let url = OPTIONMASTER + natureID;
    return this._http.get(OPTIONMASTER + natureID);
  }
  //薪资范围
  getCategorySalary() {
    let salaryID = 15;
    if (!this.salaryList) {
      return this._http.get(OPTIONMASTER + salaryID).then((data) => {
        this.salaryList = data;
        return this.salaryList;
      });
    } else {
      return Promise.resolve(this.salaryList);
    }
  }
  // 行业领域
  getCategoryIndustry() {
    if (!this.industryList) {
      return this._http.get(INDUSTRYURL).then((data) => {
        this.industryList = data;
        return this.industryList;
      });
    } else {
      return Promise.resolve(this.industryList);
    }
  }
  //岗位类型
  getCategoryJobClass() {
    return this._http.get(JOBCLASSURL);
  }
  //岗位性质
  getCategoryJobType() {
    let jobTypeID = 16;
    return this._http.get(OPTIONMASTER + jobTypeID);
  }

  //期望岗位
  getHopeJobClassData() {
    return this._http.get(HopeJobURL);
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/category-option/category-option.service.ts